module.exports = __webpack_public_path__ + "assets/img/010bf898d1972fb358614958ac477529.svg";